import { Avatar } from '@mui/material'
import { useTheme } from '@emotion/react'

const WeaponSelect = ({
  name,
  url,
  armaSelecionada,
  onClick,
  inative,
  numeroSerie,
  tipo,
  finalidade,
}) => {
  const theme = useTheme()

  return (
    <div
      onClick={onClick}
      className={`flex flex-col justify-center items-center gap-1 h-full rounded-2xl px-4 py-4 border-[3px] hover:border-primary cursor-pointer
        ${
          armaSelecionada?.nome === name &&
          armaSelecionada?.numeroSerie === numeroSerie
            ? 'border-primary '
            : theme.palette.mode === 'dark'
            ? 'border-primary-dark '
            : 'border-gray '
        }  
        ${inative ? 'opacity-20 ' : ''}
        ${theme.palette.mode === 'dark' ? 'bg-primary-dark' : 'bg-gray'}
        
        `}
    >
      <div className="relative" alt="arma selecionada">
        <Avatar
          src={url ?? './semFoto.jpeg'}
          alt="arma"
          sx={{ width: 120, height: 120 }}
        />
        {inative && (
          <div className="absolute inset-0 flex justify-center items-center opacity-100">
            <h1 className="text-white bg-danger/60 rounded-md text-sm w-full text-center transform rotate-[-30deg]">
              Inativa
            </h1>
          </div>
        )}
      </div>
      <div
        className={`text-[10px] text-center ${
          armaSelecionada?.nome === name &&
          armaSelecionada?.numeroSerie === numeroSerie &&
          ' text-primary font-bold'
        }`}
      >
        <p className="font-extrabold text-[11px] line-clamp-1">{name}</p>
        {finalidade && (
          <p>{finalidade.name ? finalidade.name : '[Sem finalidade]'}</p>
        )}
        {tipo && <p>{tipo}</p>}
        <p>(SN: {numeroSerie != '' ? numeroSerie : 'N/I'})</p>
      </div>
    </div>
  )
}

export default WeaponSelect
